import React from 'react'
import { ParentSize } from '@visx/responsive'
import { DataProvider, XYChart, AnimatedAxis, AnimatedBarGroup, AnimatedBarSeries, Tooltip } from '@visx/xychart'

import { Attributes } from '@leverege/ui-attributes'
import { Flex, Text } from '@leverege/ui-elements'
import { chartTheme } from '../../../util/Theme'
import useAisleSessionsBarChart from './hooks/useAisleSessionsBarChart'
import ChartLegend from './ChartLegend'
import ChartTypeSelector from './ChartTypeSelector'
import AnalyticsContext from '../analytics/AnalyticsContext'

export default function AisleSessions( props ) {
  const { parentItem } = props
  
  return (
    <AnalyticsContext store={parentItem}>
      <AisleChart {...props} />
    </AnalyticsContext>
  )
}

function AisleChart( props ) {
  const { data } = props
  const { data : chartData, config, type, onSetType } = useAisleSessionsBarChart( props )
  return (
    <ParentSize parentSizeStyles={{ overflow : 'hidden', width : '100%', height : '100%' }}>
      {( { width, height } ) => ( 
        <DataProvider
          theme={chartTheme}
          xScale={config.scale.x}
          yScale={config.scale.y}>
          <XYChart
            width={width}
            height={height - 20}>
            <AnimatedAxis orientation="left" numTicks={10} label="Traffic" />
            <AnimatedAxis tickFormat={config.tickFormat.x} orientation="bottom" numTicks={chartData.length} />
            <AnimatedBarGroup>
              {data?.items?.map( ( item ) => {
                const name = Attributes.get( 'name', item ) || item.data?.name
                return (
                  <AnimatedBarSeries
                    key={item.id}
                    dataKey={name}
                    data={chartData}
                    {...config.accessors.aisles[item.id]} />
                )
              } )}
            </AnimatedBarGroup>
            <Tooltip
              scroll
              detectBounds
              snapTooltipToDatumX={false}
              snapTooltipToDatumY={false}
              renderTooltip={props => (
                <AisleSessionsTooltip {...props} config={config} />
              )} />
          </XYChart>
          <ChartLegend />
          <ChartTypeSelector
            value={type}
            onChange={onSetType} />
        </DataProvider>
      )}
    </ParentSize>
  )
}

function AisleSessionsTooltip( props ) {
  const { tooltipData : { nearestDatum }, config } = props

  return (
    <Flex variant="colM">
      <Text variant="formTitle">{nearestDatum.datum.day}</Text>
      {Object
        .entries( nearestDatum.datum.aisles )
        .map( ( [ key, aisle ] ) => {
          return (
            <Flex key={key} variant="rowM" align="center">
              <Text variant="detailLabel">{aisle.name}</Text>
              <Text variant="detailValue">{config.accessors.aisles[key].yAccessor( nearestDatum.datum )}</Text>
            </Flex>
          )
        } )}
    </Flex>
  )
}
